import { gql } from 'apollo-boost'
// import gql from "graphql-tag";
// export const GET_NAMES = gql`
// query
// {
// 	plans(product: "Partyline", planType:"common") {
// 	  number
// 	  planIds
// 	}
//   }
// `;

export const GET_NAMES = gql`
  query($customerId: ID!, $product: String!, $objectId: String, $planId: String, $classification: Int, $excludeGlobal: Boolean) {
    plan(customerId: $customerId, product: $product, objectId: $objectId, planId: $planId, classification: $classification, excludeGlobal: $excludeGlobal) {
      number
      plans{
        id
        name
        serviceType
        status
        custom
        metadata
        chargeCycle
        trialTime
        measurementPay
        description
        classification
        planType
        chargeItems{
          addonId
          addonName
          serviceType
          metadata
          status
          quantity
          price
          chargeUnit
          action
          tokens
          permissionCheck
          maxQuantity
          minQuantity
        }
      }
	}
  }
`
// permissionCheck 1 不显示
export const SKUTOKENLIST = gql`
  query($customerId: ID!, $product: String!, $excludeGlobal: Boolean) {
    plan(customerId: $customerId, product: $product, excludeGlobal: $excludeGlobal) {
    number
    plans{
      id
      serviceType
      status
      custom
      metadata
      classification
      chargeItems{
        permissionCheck
        addonId
        addonName
        serviceType
        metadata
        quantity
        tokens
        maxQuantity
        minQuantity        
      }
    }
	}
  }
`
// plan(customerId: "justinchen@tvunetworks.com", product: "Partyline", planId: "mm_fednet_special_knbc_0")

export const GET_PLAN_DETAILS = gql`
query($customerId: String!, $product: String!, $planId: String!) {
	plan(customerId: $customerId, product: $product, planId: $planId) {
		chargeItems {
		  id
		  name
		  pricingModel
		  chargeType
		  price
		  periodUnit
		  status
		  enabledInPortal
		  isShippable
		  updatedAt
		  resourceVersion
		  object
		  currencyCode
		  taxable
		  type
		  cfTvuServiceType
		  cfBillingType
		  showDescriptionInInvoices
		  showDescriptionInQuotes
		}
		cfBillingCredit
		planId
		name
		price
		period
		periodUnit
		pricingModel
		description
		status
		addonApplicability
		chargeModel
		cfBillingCredit
		pricingModel
		attachedItems {
			quantity
		}
		credit
		remainingCredit		
	  }
}
`

export const GET_PLAN_PRICE = gql`
  query($customerId: ID!, $product:String!, $planId: String!,$proportionCalculation: Boolean, $chargeItems: String){
    previewCustomSubscription(
      customerId:$customerId, 
      product: $product, 
      planId: $planId,
      proportionCalculation: $proportionCalculation,
      chargeItems:$chargeItems){
        price
        quantity
    }
  }`

export const GET_SUBS = gql`
  query($product:String, $status: Int, $classification: Int $planId:String, $objectId: String){
    subscription(
      planId:$planId,
      product: $product, 
      objectId: $objectId,
      classification: $classification,
      status:$status){
        number
        subscriptions {
          id
          status
          createTime
          invalidInvoiceId
          paymentTime
          effectiveTime
          postPay
          price
          planId
          custom
          serviceType
          metadata
          chargeCycle
          trialTime
          measurementPay
          planName
          duePaymentTime
          classification
          pendingCancel
          pendingPlanId
          pendingPlanName
          pendingEffectiveDate
          paymentMode
          chargeItems {
            addonId
            addonName
            serviceType
            metadata
            status
            quantity
            price
            chargeUnit
            action
            maxQuantity
            minQuantity                   
          }
          pretreatmentChargeItems {
            addonId
            addonName
            serviceType
            metadata
            status
            quantity
            price
            chargeUnit
            action
          }
        }
    }
  }`

// 查询用户卡的信息

export const CHECK_CUSTOMER = gql`
  query($product: String!) {
    customer(product: $product) {
      cardStatus
      unbilledCharges
    }
  }`

// 获取customerPortal

export const GET_CUSTOMERPORTAL = gql`
  query($customerId: ID!, $product: String!) {
    customerPortal(customerId: $customerId, product: $product) {
      url
    }
  }`

// 获取用户绑定的card list
export const PAYMENTMETHODLIST = gql`
  query($customerId: ID!, $product: String!) {
    paymentMethodList(customerId: $customerId, product: $product) {
      id
      card {
        brand
        country
        description
        expMonth
        expYear
        last4
      }
      type
      created
    }
  }`

// 查询支付完成后的信息
export const PaymentMethodInfoByIntentId = gql`
  query($paymentIntentId: String!) {
    paymentMethodInfoByIntentId(paymentIntentId: $paymentIntentId) {
      id
      type
      created
      customer
      card{
        brand
        country
        description
        expMonth
        expYear
        last4
      }
    }
  }`

// 查询白名单
export const WhiteList = gql`
  query(
    $mappingType: Int,
    $product: String,
    $email: String,
    $teamName: String
  ) {
  whiteList(
    mappingType: $mappingType, 
    product: $product, 
    email: $email,
    teamName: $teamName
  ) {
    teamId
    teamName
    chargeTime
    postPay
    serviceType
    planId
    userId
    email
    type
    operationUser
    operationTime
    whiteListEndTime
    note
  }
}`
